// Default export: pre-existing selector used by ApplicationHeader to check for an active bar notification.
// `currentNotification(state)` returns the current bar notification object (empty {} when none).
const currentNotification = state => state.notifications.bar.currentNotification
export default currentNotification

// E3a — Working Circle Notification selectors
// Used by ApplicationHeader (badge count) and WorkingCircleNotificationDropdown (items list).

/** Returns all pending working circle notification items: { type, connectionId, profile, sharedCount } */
export const selectWorkingCircleNotifications = state => state.notifications.workingCircle.items

/**
 * Returns the count of unread working circle notifications — used for the nav badge.
 * Accepts an optional profileId to filter out social_overlap items the user has already
 * dismissed via localStorage (same filter applied in WorkingCircleNotificationDropdown).
 */
export const selectUnreadCount = (state, profileId) => {
  const { items } = state.notifications.workingCircle
  if (!profileId) return items.length

  let dismissedIds = []
  try {
    dismissedIds = JSON.parse(localStorage.getItem(`dismissed_overlaps_${profileId}`)) || []
  } catch {
    // localStorage unavailable — count all items
  }

  return items.filter(item => item.type !== 'social_overlap' || !dismissedIds.includes(item.id)).length
}

/** True while the fetch is in flight. */
export const selectIsFetching = state => state.notifications.workingCircle.isFetching

/** True while a dismiss request is in flight. */
export const selectIsDismissing = state => state.notifications.workingCircle.isDismissing
